module.exports = __webpack_public_path__ + "img/Logo_Adeo.8e9accd7.png";